export const environment = {
    production: true,
    sendContactRequestUrl: 'https://proclient4.beta.biz/BetaTools.ProClient.Web/Services/Service.svc/SendContactRequest',

};



// WEBPACK FOOTER //
// ./src/environments/environment.ts